import { debounce } from "lodash";
import { inviteUser, inviteUserData } from "../types";

const debouncedCache: Record<string, ReturnType<typeof debounce>> = {};

export const getDebouncedUpdater = (
  teamID: string,
  field: keyof inviteUserData,
  setInviteList: React.Dispatch<React.SetStateAction<inviteUser>>
) => {
  const cacheKey = `${teamID}-${field}`;

  if (!debouncedCache[cacheKey]) {
    debouncedCache[cacheKey] = debounce((value: string) => {
      setInviteList((prev) => {
        if (!prev?.data) return prev;
        const updatedData = prev.data.map((item) =>
          item._id === teamID ? { ...item, [field]: value } : item
        );
        return { ...prev, data: updatedData };
      });
    }, 500);
  }

  return debouncedCache[cacheKey];
};

export const parseCSVFile = (fileText: string) => {
  const csvHeader = fileText.slice(0, fileText.indexOf("\n")).split(",");
  const csvRows = fileText.slice(fileText.indexOf("\n") + 1).split("\n");

  const array = csvRows.map((i) => {
    const values = i.split(",");
    const obj = csvHeader.reduce((object, header, index) => {
      object[header] = values[index];
      return object;
    }, {} as Record<string, string>);
    return obj;
  }).filter(item => {
    for (let key in item) {
      if (item[key] === undefined || item[key] === "") {
        return false;
      }
    }
    return true;
  });

  return array;
};


export const isInviteListValid = (inviteList) => {
  if (
    !inviteList?.data?.length ||
    !inviteList?.startDate?.trim() ||
    !inviteList?.selectedInvoiceSeats ||
    Object.keys(inviteList.selectedInvoiceSeats).length === 0
  ) {
    return false;
  }

  return inviteList.data.every((user) => {
    return (
      user.first?.trim() &&
      user.last?.trim() &&
      user.email?.trim() &&
      user.productID?.trim() &&
      user.roles?.[0]?.groupID?.trim() &&
      user.roles?.[0]?.roleName?.trim() &&
      user.roles?.[0]?.groupName?.trim()
    );
  });
};

export const isRunValidationInviteListValid = (inviteList,userValidationData) =>{
    return inviteList?.data?.length === Object.keys(userValidationData)?.length
}